import { render, staticRenderFns } from "./WorkExperience.vue?vue&type=template&id=5313c024&scoped=true&"
import script from "./WorkExperience.vue?vue&type=script&lang=ts&"
export * from "./WorkExperience.vue?vue&type=script&lang=ts&"
import style0 from "./WorkExperience.vue?vue&type=style&index=0&id=5313c024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313c024",
  null
  
)

export default component.exports